import { useField } from 'formik';
import React, { useEffect, useState } from 'react';
import { useGetAllCountryCodeListQuery } from '../../Apis/Common/SPCommonServicesApi';
import { convertData, rtkErrorRead } from '../../Helper';
import { SelectOption } from '../../Interfaces/PIMs';
import { PhoneNumberInputProps } from '../../Interfaces/Props';
import SelectComp from './SelectComp';

const PhoneComp: React.FC<PhoneNumberInputProps> = (props) => {
  const { data, isLoading, isError, error } =
    useGetAllCountryCodeListQuery(null);

  const [countryCodeList, setCountryCodeList] = useState<SelectOption[]>([]);
  const [countryCodeField, countryCodeMeta, countryCodeHelpers] = useField(
    props.fieldsCountryCodeName
  );
  const [phoneField, phoneMeta, phoneHelpers] = useField(props.fieldsPhoneName);

  useEffect(() => {
    if (isError) {
      rtkErrorRead(error);
    } else {
      if (!isLoading) {
        setCountryCodeList(convertData(data.result) || []);
      }
    }
  }, [data, isLoading, isError, error]);

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="relative flex-1 custom-select">
          <SelectComp
            className="w-full"
            placeholder="Choose..."
            value={countryCodeList.find(
              (option) =>
                option.value != null &&
                countryCodeField.value != null &&
                Number(option.value) === Number(countryCodeField.value)
            )}
            onBlur={() => countryCodeHelpers.setTouched(true)}
            onChange={(newValue) => {
              const selectedOption = newValue as SelectOption;
              countryCodeHelpers.setValue(
                selectedOption?.value !== undefined
                  ? Number(selectedOption?.value)
                  : null
              );
            }}
            options={countryCodeList}
            isLoading={isLoading}
            isClearable
            isSearchable
            isDisabled={props.disabled}
          />
          {countryCodeMeta.touched && countryCodeMeta.error ? (
            <div className="text-red-500 mt-1">{countryCodeMeta.error}</div>
          ) : null}
        </div>
        <div className="flex-1">
          <input
            type="number"
            className={props.className}
            value={phoneField.value}
            onBlur={() => phoneHelpers.setTouched(true)}
            onChange={(e) => phoneHelpers.setValue(e.target.value)}
            placeholder={props.placeholder}
            disabled={props.disabled}
          />
          {phoneMeta.touched && phoneMeta.error ? (
            <div className="text-red-500 mt-1">{phoneMeta.error}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PhoneComp;
